import { render, staticRenderFns } from "./NoticeCombined.vue?vue&type=template&id=f9766b56&"
import script from "./NoticeCombined.vue?vue&type=script&lang=js&"
export * from "./NoticeCombined.vue?vue&type=script&lang=js&"
import style0 from "./NoticeCombined.vue?vue&type=style&index=0&id=f9766b56&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports